module.exports = __webpack_public_path__ + "static/welcome2-4f69d1ba798a4317bc2d23742f3efdd2.webp";